import { api, setAccessToken } from "@/lib/api";
import type { LoginCredentials, LoginResponse, UserSummary } from "./types";

export async function login(credentials: LoginCredentials): Promise<LoginResponse> {
  const res = await api.post<LoginResponse>("/auth/login", credentials);
  setAccessToken(res.access_token);
  return res;
}

export async function logout(): Promise<void> {
  try {
    await api.post("/auth/logout");
  } finally {
    // Clear local state even if the request fails. Leaving a stale token in
    // memory after the user clicked "sign out" is worse than a failed call.
    setAccessToken(null);
  }
}

export function fetchMe(): Promise<UserSummary> {
  return api.get<UserSummary>("/auth/me");
}

export function changePassword(body: {
  current_password: string;
  new_password: string;
}): Promise<{ message: string }> {
  return api.post<{ message: string }>("/auth/change-password", body);
}

export interface SignupPayload {
  full_name: string;
  email: string;
  password: string;
  company_name: string;
  phone: string;
  city?: string;
}

export function signup(payload: SignupPayload): Promise<{ message: string }> {
  return api.post<{ message: string }>("/auth/signup", payload);
}

export function forgotPassword(email: string): Promise<{ message: string }> {
  return api.post<{ message: string }>("/auth/forgot-password", { email });
}

export function resetPassword(
  token: string,
  new_password: string,
): Promise<{ message: string }> {
  return api.post<{ message: string }>("/auth/reset-password", { token, new_password });
}
